var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Components, PropertyConverters, Utils, P, PCSS, CustomElement, Watch, Defaults, ViewChild, CustomEventUtils, CustomElementUtils, avoidHandler, UI } from '@pacem/pacem-core';
import { Components as ComponentsUI } from '@pacem/pacem-ui';
import { PacemBaseElement } from './types-components';
//namespace Components.Scaffolding {
class HierarchyChangeEvent extends CustomEvent {
    constructor(v) {
        super('hierarchychange', { detail: v, bubbles: false, cancelable: false });
    }
}
const HIERARCHYITEM_CSSCLASS = 'hierarchy-item';
const HIERARCHYITEM_CSSCLASS_FULL = HIERARCHYITEM_CSSCLASS + ' ' + PCSS + '-anim anim-fade-in anim-sudden';
const HIERARCHYITEM_CSSCLASS_ATTR = "{{ { 'item-disabled' : ^item.disabled } }}";
const BINDER_HIERARCHYDATAKEY = 'pacemHierarchy';
const HIERARCHYITEM_CONTENT_CSSCLASS = 'item-content';
const HIERARCHYITEM_LINK_CSSCLASS = 'item-link';
const HIERARCHYITEM_LINK_CSSCLASS_FULL = HIERARCHYITEM_LINK_CSSCLASS + ' icon-rotate rotate-135';
const HIERARCHYITEM_LINK_ICON = 'link';
const HIERARCHYITEM_MOVE_CSSCLASS = 'item-move';
const HIERARCHYITEM_MOVE_ICON = 'drag_indicator';
const DEFAULT_PARENTSPROPERTY = 'parents';
let PacemHierarchyElement = class PacemHierarchyElement extends PacemBaseElement {
    getViewValue(value) {
        return '';
    }
    convertValueAttributeToProperty(attr) {
        return Utils.Json.parse(attr);
    }
    constructor() {
        super();
        this.#bindings = new Map();
        this.#dropTargets = new Map();
        this.unlinkCaption = 'Delete';
        this._binderClickHandler = (evt) => {
            const origType = evt.originalEvent.type;
            if (origType === 'mousedown' && evt.originalEvent.button === 1) {
                avoidHandler(evt.originalEvent);
                const binder = evt.srcElement;
                this._unlink(binder);
            }
            else if (origType === 'click' || origType === 'contextmenu') {
                avoidHandler(evt.originalEvent);
                this.#unlinkingBinder = evt.srcElement;
                const balloon = this._balloon;
                balloon.target = { x: evt.pageX, y: evt.pageY };
                balloon.popup();
            }
        };
        // #region drag-drop
        this._dragInitHandler = (evt) => {
            let args = evt.detail;
            const dragger = this._dragger;
            dragger.floater = document.createElement('span');
            dragger.dropTargets = Array.from(this.#dropTargets.keys()).filter(i => i !== args.element);
            if (!Utils.isNull(this.#dragBinder)) {
                this.#dragBinder.remove();
            }
            const binder = this.#dragBinder = new ComponentsUI.UI.PacemBinderElement();
            binder.from = args.element;
            this.#shell.appendChild(binder);
        };
        this._dragStartHandler = (evt) => {
            Utils.addClass(evt.detail.element, 'item-drag');
        };
        this._dragHandler = (evt) => {
            this.#dragBinder.to = evt.detail.currentPosition;
        };
        this._dragEndHandler = (evt) => {
            Utils.removeClass(evt.detail.element, 'item-drag');
            this.#dragBinder.remove();
            this.#dragBinder = null;
        };
        this._dropHandler = (evt) => {
            const source = evt.detail.data, target = this.#dropTargets.get(evt.detail.target);
            // set source as a parent of target
            // just in case (double-check)
            if (!this._isInAncestors(source, target) && !this._isInDescendants(source, target)) {
                // set new relation
                this._compileHierarchy({ source, target });
            }
        };
        this._dragOverHandler = (evt) => {
            const source = evt.detail.data, target = this.#dropTargets.get(evt.detail.target);
            if (target.disabled || this._isInAncestors(source, target) || this._isInDescendants(source, target)) {
                evt.preventDefault();
            }
        };
        this._dragOutHandler = (evt) => {
        };
        // #endregion
        // #region balloon
        this._popoutHandler = (evt) => {
            this._balloon.popout();
        };
        this.#key = Utils.uniqueCode();
    }
    #key;
    #bindings;
    #dragBinder;
    #unlinkingBinder;
    #dropTargets;
    #shell;
    get inputFields() {
        return [];
    }
    toggleReadonlyView(readonly) {
        this._dragger.disabled = readonly;
        if (!Utils.isNull(this._adaptedDatasource)) {
            this._databind();
        }
    }
    onChange(evt) {
        return new Promise((resolve, reject) => {
            if (CustomEventUtils.isInstanceOf(evt, HierarchyChangeEvent)) {
                resolve(this.value = evt.detail);
            }
            resolve(this.value);
        });
    }
    acceptValue(val) {
        // nothing peculiar to do...
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this.#shell = CustomElementUtils.findAncestorShell(this);
        this._setupItemTemplate();
        this._setupDragger();
        this._setupBalloon();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'datasource':
            case 'textProperty':
            case 'disabledProperty':
            case 'valueProperty':
                cancelAnimationFrame(this._handle);
                this._handle = requestAnimationFrame(() => {
                    this._buildAdaptedDatasource();
                });
                break;
            case 'itemtemplate':
                if (!first) {
                    this._setupItemTemplate();
                }
                break;
            case '_adaptedDatasource':
            case 'value':
                cancelAnimationFrame(this._handle2);
                this._handle2 = requestAnimationFrame(() => {
                    this._databind();
                });
                break;
        }
    }
    disconnectedCallback() {
        this._disposeDragger();
        this._disposeBalloon();
        super.disconnectedCallback();
    }
    _buildAdaptedDatasource(ds = this.datasource) {
        this._adaptedDatasource = ds && ds.map(i => this._mapEntityToItem(i));
    }
    _mapEntityToValue(entity) {
        let value = entity, prop;
        if (prop = this.valueProperty) {
            value = entity[prop];
        }
        return value;
    }
    _mapEntityToViewValue(entity) {
        let viewValue = entity.toString(), prop;
        if (prop = this.textProperty) {
            viewValue = entity[prop];
        }
        return viewValue;
    }
    _mapEntityToItem(entity) {
        if (entity == null) {
            throw new Error('Entity cannot be null');
        }
        // databound
        let disabled = false;
        const disabledProp = this.disabledProperty;
        if (!Utils.isNullOrEmpty(disabledProp)) {
            disabled = entity[disabledProp] || false;
        }
        return { value: this._mapEntityToValue(entity), viewValue: this._mapEntityToViewValue(entity), disabled: disabled, data: entity };
    }
    _unlink(arg) {
        var binder;
        if (arg instanceof ComponentsUI.UI.PacemBinderElement) {
            binder = arg;
        }
        else {
            arg.preventDefault();
            arg.stopPropagation();
            binder = this.#unlinkingBinder;
        }
        const { parent, child } = JSON.parse(binder.dataset[BINDER_HIERARCHYDATAKEY]);
        const ds = this._adaptedDatasource, source = ds.find(i => i.value === parent), target = ds.find(i => i.value === child);
        if (!source.disabled && !target.disabled) {
            this._compileHierarchy({ source, target }, true);
        }
    }
    _buildHierarchyItemDomId(itemId) {
        return `hierarchyitem_${this.#key}_${itemId}`;
    }
    _itemCreate(evt) {
        const item = evt.detail.dom.find(i => i instanceof HTMLElement && i.classList.contains(HIERARCHYITEM_CSSCLASS)), index = evt.detail.index, hierarchyItem = evt.detail.item;
        item.id = this._buildHierarchyItemDomId(hierarchyItem.value);
        if (hierarchyItem.disabled) {
            item.setAttribute('behaviors', '{{ [#' + this._dragger2.id + '] }}');
        }
        else {
            item.setAttribute('behaviors', '{{ [#' + this._dragger.id + ', #' + this._dragger2.id + '] }}');
        }
        for (let parent of hierarchyItem.parents || []) {
            const binder = new ComponentsUI.UI.PacemBinderElement();
            binder.to = item;
            binder.toAnchor = ComponentsUI.UI.BinderAnchor.Top;
            binder.toEnd = ComponentsUI.UI.BinderEnd.Arrow;
            binder.setAttribute('from', '{{ #' + this._buildHierarchyItemDomId(parent.value) + ' }}');
            binder.fromAnchor = ComponentsUI.UI.BinderAnchor.Bottom;
            binder.cssClass = ['hierarchy-binder'];
            binder.interactive = !this.readonly && !hierarchyItem.disabled && !parent.disabled;
            binder.addEventListener(ComponentsUI.UI.BinderInteractionEventName, this._binderClickHandler, false);
            binder.dataset[BINDER_HIERARCHYDATAKEY] = JSON.stringify({ parent: parent.value, child: hierarchyItem.value });
            this.#bindings.set(hierarchyItem.value, binder);
            this.#shell.appendChild(binder);
        }
        if (!this.#dropTargets.has(item)) {
            this.#dropTargets.set(item, hierarchyItem);
        }
    }
    _itemRemove(evt) {
        const item = evt.detail.dom.find(i => i instanceof HTMLElement && i.classList.contains(HIERARCHYITEM_CSSCLASS)), hierarchyItem = evt.detail.item, bindings = this.#bindings;
        if (bindings.has(hierarchyItem.value)) {
            const binder = bindings.get(hierarchyItem.value);
            binder.removeEventListener(ComponentsUI.UI.BinderInteractionEventName, this._binderClickHandler, false);
            binder.remove();
            bindings.delete(hierarchyItem.value);
        }
        if (this.#dropTargets.has(item)) {
            this.#dropTargets.delete(item);
        }
    }
    _setupItemTemplate() {
        if (this.itemtemplate instanceof HTMLTemplateElement) {
            const frag = this.itemtemplate.cloneNode(true).content;
            const tmpl = document.createElement('template');
            const wrapper = document.createElement(P + '-panel');
            wrapper.className = HIERARCHYITEM_CSSCLASS_FULL;
            wrapper.setAttribute('css-class', HIERARCHYITEM_CSSCLASS_ATTR);
            const move = new ComponentsUI.UI.PacemIconElement();
            move.setAttribute('icon', HIERARCHYITEM_MOVE_ICON);
            move.className = HIERARCHYITEM_MOVE_CSSCLASS;
            wrapper.appendChild(move);
            const content = document.createElement('div');
            content.className = HIERARCHYITEM_CONTENT_CSSCLASS;
            content.append(frag);
            wrapper.appendChild(content);
            const link = new ComponentsUI.UI.PacemIconElement();
            link.setAttribute('icon', HIERARCHYITEM_LINK_ICON);
            link.className = HIERARCHYITEM_LINK_CSSCLASS_FULL;
            wrapper.appendChild(link);
            tmpl.content.appendChild(wrapper);
            this._template = tmpl;
        }
        else {
            this._template = this._defaultTemplate;
        }
    }
    _compileHierarchy(relation, remove = false) {
        const value = /* clone to detach any referemce with the original value, thus allowing `reset` */ Utils.clone(this.value || []);
        const newParent = relation.source.value, newChild = relation.target.value;
        const parentsProperty = this.parentsProperty || DEFAULT_PARENTSPROPERTY;
        var found = value.find(i => i[this.valueProperty] === newChild);
        if (remove) {
            if (!Utils.isNull(found)) {
                const parents = found[parentsProperty] || [], ndx = parents.indexOf(newParent);
                if (ndx >= 0) {
                    parents.splice(ndx, 1);
                }
            }
        }
        else {
            if (Utils.isNull(found)) {
                found = {};
                found[this.valueProperty] = newChild;
                found[parentsProperty] = [];
                value.push(found);
            }
            found[parentsProperty].push(newParent);
        }
        // cleanup
        this._cleanupHierarchy(value);
        //
        this.changeHandler(new HierarchyChangeEvent(value));
    }
    _cleanupHierarchy(value = []) {
        const valueProperty = this.valueProperty, parentsProperty = this.parentsProperty || DEFAULT_PARENTSPROPERTY;
        const isInAncestors = (sourceId, targetId) => {
            const target = value.find(i => i[valueProperty] == targetId);
            if (Utils.isNull(target) || Utils.isNullOrEmpty(target[parentsProperty])) {
                return false;
            }
            const parents = target[parentsProperty];
            if (parents.indexOf(sourceId) >= 0) {
                return true;
            }
            return parents.some(p => isInAncestors(sourceId, p));
        };
        // bottom-up: if a parent is also an ancestor, then remove the link
        for (let v of value) {
            const parents = v[parentsProperty] || [];
            for (let j = parents.length - 1; j >= 0; j--) {
                const parent = parents[j];
                const otherParents = parents.filter(p0 => p0 !== parent);
                for (let otherParent of otherParents) {
                    if (isInAncestors(parent, otherParent)) {
                        parents.splice(j, 1);
                        break;
                    }
                }
            }
        }
    }
    _setupDragger() {
        const dragger = this._dragger;
        dragger.id = 'hierarchy_link_' + this.#key;
        dragger.handleSelector = '.' + HIERARCHYITEM_LINK_CSSCLASS;
        dragger.dropBehavior = UI.DropBehavior.None;
        dragger.spillBehavior = UI.DropTargetMissedBehavior.None;
        dragger.mode = UI.DragDataMode.Copy;
        dragger.addEventListener(UI.DragDropEventType.Drop, this._dropHandler, false);
        dragger.addEventListener(UI.DragDropEventType.Drag, this._dragHandler, false);
        dragger.addEventListener(UI.DragDropEventType.Init, this._dragInitHandler, false);
        dragger.addEventListener(UI.DragDropEventType.Start, this._dragStartHandler, false);
        dragger.addEventListener(UI.DragDropEventType.End, this._dragEndHandler, false);
        dragger.addEventListener(UI.DragDropEventType.Over, this._dragOverHandler, false);
        dragger.addEventListener(UI.DragDropEventType.Out, this._dragOutHandler, false);
        const dragger2 = this._dragger2;
        dragger2.id = 'hierarchy_move_' + this.#key;
        dragger2.mode = UI.DragDataMode.Self;
        dragger2.dropBehavior = UI.DropBehavior.None;
        dragger2.spillBehavior = UI.DropTargetMissedBehavior.None;
        dragger2.handleSelector = '.' + HIERARCHYITEM_MOVE_CSSCLASS;
    }
    _disposeDragger() {
        const dragger = this._dragger;
        if (!Utils.isNull(dragger)) {
            dragger.removeEventListener(UI.DragDropEventType.Drop, this._dropHandler, false);
            dragger.removeEventListener(UI.DragDropEventType.Drag, this._dragHandler, false);
            dragger.removeEventListener(UI.DragDropEventType.Init, this._dragInitHandler, false);
            dragger.removeEventListener(UI.DragDropEventType.Start, this._dragStartHandler, false);
            dragger.removeEventListener(UI.DragDropEventType.End, this._dragEndHandler, false);
            dragger.removeEventListener(UI.DragDropEventType.Over, this._dragOverHandler, false);
            dragger.removeEventListener(UI.DragDropEventType.Out, this._dragOutHandler, false);
        }
    }
    _setupBalloon() {
        this._balloon = this._shellProxy.dom.find(i => i instanceof ComponentsUI.UI.PacemBalloonElement);
        window.addEventListener('mousedown', this._popoutHandler, false);
    }
    _disposeBalloon() {
        window.removeEventListener('mousedown', this._popoutHandler, false);
    }
    // #endregion
    _isInAncestors(source, target) {
        if (Utils.isNull(target) || Utils.isNullOrEmpty(target.parents)) {
            return false;
        }
        if (target.parents.indexOf(source) >= 0) {
            return true;
        }
        return target.parents.some(p => this._isInAncestors(source, p));
    }
    _isInDescendants(source, target) {
        return this._isInAncestors(target, source);
    }
    _databind() {
        // clear binders
        this._repeater.datasource = [];
        // check value property
        const valueProperty = this.valueProperty;
        if (Utils.isNullOrEmpty(valueProperty)) {
            throw new Error('Missing valueProperty.');
        }
        // merge datasource and value
        const ds = Utils.clone(this._adaptedDatasource || []), mapping = this.value || [], parentsProperty = this.parentsProperty || DEFAULT_PARENTSPROPERTY;
        for (let item of ds) {
            const found = mapping.find(i => i[valueProperty] === item.value);
            if (!Utils.isNull(found)) {
                item.parents = (found[parentsProperty] || []).map(i => ds.find(i0 => i0.value === i)).filter(i => !Utils.isNull(i));
            }
        }
        // layerize and bind to repeater
        this._databindByParents(ds);
    }
    _databindByParents(ds) {
        // naive algo:
        // find topmost then loop-find direct-only children until no more descendant remains.
        const levelMatrix = [];
        function count() {
            return levelMatrix.reduce((previousLength, item) => previousLength + item.length, 0);
        }
        do {
            if (Utils.isNullOrEmpty(levelMatrix)) {
                // topmost
                const topmost = ds.filter((i) => Utils.isNullOrEmpty(i.parents));
                levelMatrix.push(topmost);
            }
            else {
                // other levels
                const upperLevels = Array.prototype.concat.apply([], levelMatrix), upperLevel = levelMatrix[levelMatrix.length - 1];
                const level = ds.filter((i) => {
                    if (Utils.isNullOrEmpty(i.parents)) {
                        return false;
                    }
                    return i.parents.every(p => upperLevels.indexOf(p) >= 0) && i.parents.some(p => upperLevel.indexOf(p) >= 0);
                });
                levelMatrix.push(level);
            }
        } while (count() < ds.length);
        // databind
        this._repeater.datasource = levelMatrix;
    }
};
__decorate([
    ViewChild('template[default]')
], PacemHierarchyElement.prototype, "_defaultTemplate", void 0);
__decorate([
    ViewChild(P + '-repeater')
], PacemHierarchyElement.prototype, "_repeater", void 0);
__decorate([
    ViewChild(P + '-drag-drop')
], PacemHierarchyElement.prototype, "_dragger", void 0);
__decorate([
    ViewChild(P + '-drag-drop[move]')
], PacemHierarchyElement.prototype, "_dragger2", void 0);
__decorate([
    ViewChild(P + '-shell-proxy')
], PacemHierarchyElement.prototype, "_shellProxy", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Json })
], PacemHierarchyElement.prototype, "datasource", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemHierarchyElement.prototype, "valueProperty", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemHierarchyElement.prototype, "textProperty", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemHierarchyElement.prototype, "disabledProperty", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemHierarchyElement.prototype, "unlinkCaption", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Json })
], PacemHierarchyElement.prototype, "_adaptedDatasource", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Element })
], PacemHierarchyElement.prototype, "itemtemplate", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Element })
], PacemHierarchyElement.prototype, "_template", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemHierarchyElement.prototype, "parentsProperty", void 0);
PacemHierarchyElement = __decorate([
    CustomElement({
        tagName: P + '-hierarchy', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<${P}-repeater>
        <template>
            <${P}-repeater on-${Components.RepeaterItemCreateEventName}=":host._itemCreate($event)" on-${Components.RepeaterItemRemoveEventName}=":host._itemRemove($event)" datasource="{{ ^item }}">
                <div class="hierarchy-level">
                    <${P}-template-proxy target="{{ :host._template }}"></${P}-template-proxy>
                </div>
            </${P}-repeater>
        </template>
    </div>
</${P}-repeater><${P}-content></${P}-content>
<${P}-drag-drop></${P}-drag-drop>
<${P}-drag-drop move></${P}-drag-drop>
<template default>
    <${P}-panel class="${HIERARCHYITEM_CSSCLASS_FULL} item-default" css-class="${HIERARCHYITEM_CSSCLASS_ATTR}">
        <${P}-icon class="${HIERARCHYITEM_MOVE_CSSCLASS}" icon="${HIERARCHYITEM_MOVE_ICON}"></${P}-icon>
        <pacem-span class="${HIERARCHYITEM_CONTENT_CSSCLASS}" content="{{ ^item.viewValue }}"></${P}-span>
        <${P}-icon class="${HIERARCHYITEM_LINK_CSSCLASS_FULL}" icon="${HIERARCHYITEM_LINK_ICON}"></${P}-icon>
    </${P}-panel>
</template>
<${P}-shell-proxy>
        <${P}-balloon options="{{ { behavior: ComponentsUI.UI.BalloonBehavior.Inert } }}">
                    <${P}-button icon-glyph="link_off" class="${PCSS}-margin margin-0 button-flat display-flex flex-middle icon-rotate rotate-135"
                                 on-click=":host._unlink($event)"
                                 on-mousedown="$event.stopPropagation()"
                                 on-mouseup="::_balloon.popout()"><${P}-text class="${PCSS}-margin margin-left-1" text="{{ :host.unlinkCaption }}"></${P}-text></${P}-button>
        </${P}-balloon>
</${P}-shell-proxy>`
    })
], PacemHierarchyElement);
export { PacemHierarchyElement };
